
import { copyToClipboard } from 'quasar'
import { Component, Prop, Vue } from 'vue-property-decorator'

import SpeiModel from '../models/Spei'

import EButton from './Button.vue'
import EPaymentInfo from './PaymentInfo.vue'

@Component({
  components: {
    EButton,
    EPaymentInfo,
  },
})
export default class Spei extends Vue {
  @Prop({ required: true }) readonly spei!: SpeiModel

  copied = false;

  async copyClabe() {
    try {
      await copyToClipboard(this.spei.clabe)

      this.copied = true
      this.$emit('copy')
      setTimeout(() => { this.copied = false }, 1100)
    } catch (err) {
      console.error(err)
    }
  }
}
